import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import { PACKAGES } from '../utils/constants';

const styles = theme => {
  return Object.assign({
  }, globalStyles);
};

class SelectSubscriptionCard extends Component {

  render() {

    const { classes, subscriptionIRI, onSelectSubscription, expirationDate, name, subscriptionPackage } = this.props;
    const date = expirationDate ? new Date(expirationDate) : null;
    const dateText = date ? date.toLocaleString().substring(0, 10) : "";

    return (
      <React.Fragment>
        <div data-test={"subscription-" + name}>
          <Paper
            data-test={subscriptionIRI}
            key={subscriptionIRI}
            className={classes.subscriptionCard}
            onClick={() => onSelectSubscription(subscriptionIRI)}>
            <div style={{ width: '100%', display: 'flex' }}>
              <Typography data-test="subscription-card-title" className={classes.subHeadingLarge} style={{ flex: 1 }}>{name}</Typography>
              {!expirationDate &&
                <div style={{
                  alignSelf: 'flex-end',
                  flex: '0 0'
                }}>
                </div>
              }
            </div>
            <Typography variant="body2" style={{ marginTop: 6 }}>{PACKAGES[subscriptionPackage]}</Typography>
            <div style={{ flex: 1 }}>
              {expirationDate && <Typography variant="body2" style={{
                marginBottom: 10,
                marginTop: 6,
                color: '#CA4F0C'
              }}>This subscription ends {dateText}</Typography>}
            </div>
            <div style={{ textAlign: 'right' }}>
              <Tooltip title="Go to subscription">
                <IconButton
                  aria-label={"Go to subscription " + name}
                  data-test="select-subscription"
                  size="small"
                  style={{ width: 40, height: 40, verticalAlign: 'middle', paddingTop: 6 }}>
                  <ArrowForwardIcon className={classes.actionButton} />
                </IconButton>
              </Tooltip>
            </div>
          </Paper>
        </div>
      </React.Fragment>
    );
  }
}

SelectSubscriptionCard.propTypes = {
  classes: PropTypes.object,
  subscriptionIRI: PropTypes.string.isRequired,
  expirationDate: PropTypes.number,
  onSelectSubscription: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  subscriptionPackage: PropTypes.string.isRequired
};

export default withStyles(styles)(SelectSubscriptionCard);